import 'css-chunksrc/client/scenes/constraintEdition/constrainedElement/element/milestone/styles.scss';export default {
  "milestone": "_milestone_1jssx_1",
  "iconBox": "_iconBox_1jssx_11",
  "icon": "_icon_1jssx_11"
};